abstract class AVSearch<T> {
  abstract search(keyword: string, limit: number): Promise<T[]>
  abstract setIsOhc(ohc: boolean): void
}

export default AVSearch
